enum RecipientsTableColumnSize {
  Recipient = 50,
  Variable = 50,
}

export default RecipientsTableColumnSize;
